/**
 * @file RecommendedBySchedulingListView.jsx
 * @author Daniel Aguirre
 * @description Dashboard Detail Management View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Helpers
import { useParams } from 'react-router';
import {
  joinArrayObject,
  removeNullValuesFromObject
} from 'commons/helpers/utils';
import {
  createColumns,
  getSearchApiKeys,
  getSorterString,
  PAGE_LIMIT
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function RecommendedBySchedulingListView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = useState([]);
  const { date } = useParams();

  const { getRecommendedBySchedulingList } = dashboardStaffActions;

  const [totalItems, setTotalItems] = useState(0);
  const [dataFilter, setDataFilter] = useState(null);
  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState(null);
  const [sorter, setSorter] = useState(null);

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const joinFilter = joinArrayObject(filter);
    const joinSorter = joinArrayObject(sorter);
    const data = {
      params: {
        date,
        idClinic: clinicId,
        limit: pageSize,
        offset,
        ...joinFilter,
        ...joinSorter
      }
    };
    getRecommendedBySchedulingList(data, (_, resp) => {
      if (resp?.data && resp.data?.totalRegistros != null) {
        setTotalItems(resp.data?.totalRegistros);
        setRowData(resp.data?.listaDetalles ?? []);
        setDataFilter(resp.data);
      }
    });
  };

  useEffect(() => {
    if (clinicId !== null) getetData(1);
  }, [clinicId]);

  useEffect(() => {
    const cols = createColumns(translate, dataFilter);
    setColumns(cols);
  }, [rowData, dataFilter]);

  const handleTableChange = (pagination, filters, sorterFilter) => {
    if (filters || sorterFilter) {
      const convertedFilters = getSearchApiKeys(
        columns,
        removeNullValuesFromObject(filters)
      );
      const convertedSorts = getSorterString(sorterFilter);
      setFilter(convertedFilters);
      setSorter(convertedSorts);
    }
  };

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      onPaginationChange={getetData}
      onChange={handleTableChange}
      filter={filter}
      sorter={sorter}
    />
  );
}

/**
 * Component definition of proptypes.
 */
RecommendedBySchedulingListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getRecommendedBySchedulingList: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default RecommendedBySchedulingListView;
